<template>
	<div>
		<base-header class="pb-6">
			<b-row align-v="center" class="py-4">
				<b-col lg="6" cols="7">
					<h6 class="h2 text-dark d-inline-block mb-0">Setup</h6>
				</b-col>

			</b-row>
		</base-header>

		<div class="mt--6 header pb-6 d-flex align-items-center profile-header">
			<!-- Mask -->
			<span class="mask opacity-8 bg-darker"></span>
			<!-- Header container -->
			<b-container fluid class="d-flex align-items-center">
				<b-row>
					<b-col cols="12 pt-2">
						<h1 class="display-2 text-white">Hello, {{ auth_user.name }}</h1>
						<div class="d-flex justify-content-between w-full">
							<p class="text-white">Your subscription will end on
								<span v-if="auth_user.subscription.scrb_end_date">{{ auth_user.subscription.scrb_end_date |
									dateFormatString }}</span>
								<span v-else>N/A</span>.
								<a href="javascript:void(0)" class="ml-1 btn-sm border-0 bg-fintos text-dark font-weight-bold"
									v-if="auth_user.subscription.scrb_is_my_own" @click="renewSubscription">Renew Now</a>
							</p>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>

		<b-container fluid class="mt--6">
			<edit-my-profile-form></edit-my-profile-form>
		</b-container>
	</div>
</template>
<script>
import EditMyProfileForm from '@/views/Setup/UsersFolder/UserProfile/EditMyProfileForm.vue';
import { mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
} from '@/assets/js/httpImports.js'

export default {
	name: 'my-user-profile',
	components: {
		EditMyProfileForm
	},
	mixins: [notifyFunctionMixin],
	data() {
		return {
			user: {
				name: '',
				email: '',
			}
		}
	},
	computed: {
		...mapState(useAuthStore, ['auth_user'])
	},
	created() {
		this.checkPayloadIsSuccess()
	},
	methods: {
		renewSubscription() {
			if (!this.auth_user.subscription.scrb_is_my_own) {
				this.errorFunction(null, 'You are not authorize to renew the subscription.')
				return
			}

			let message = 'This will redirect you to the payment gateway for renewal process.'
			if (confirm(message) == true) {
				let data = {
					reg_redirect: window.location.href
				}
				axios.post(services.billing + 'subscription/renewal/' + this.auth_user.subscription.scrb_id, data, { headers: getHeader() })
					.then(res => {
						const billplz_url = res.data.payment.pay_url
						window.location.href = billplz_url
					})
					.catch(e => {
						this.errorFunction(e)
					})
			}

		},
		checkPayloadIsSuccess() {
			let payload = this.$route.query.payload
			if (!payload) {
				return
			}
			let decodePayload = JSON.parse(Buffer.from(payload, 'base64').toString('utf-8'));

			// check for renewal
			if (decodePayload.pay_type === 'RENEWAL_SUBSCRIPTION') {
				if (decodePayload.pay_paid_status.toLowerCase() === 'failed') {
					this.errorFunction(null, 'Subscription Renewal - Failed')
				}
				if (decodePayload.pay_paid_status.toLowerCase() === 'paid') {
					this.notifySuccess('Subscription Renewal - Successfully.')
				}
			}

			const queryParams = { ...this.$route.query };
			delete queryParams.payload;
			delete queryParams.success;
			this.$router.replace({ query: queryParams });
		},
	}
};
</script>
<style>
.profile-header {
	background-size: cover;
	background-position: center top;
	min-height: 200px;
}
</style>
